<template>
  <div
    :data-step="number"
    :class="['step', { completed: step > number }, { active: step == number }]"
  >
    <span class="title">{{ name }}</span>
    <span class="badge">{{ number }}</span>
  </div>
</template>

<script>
export default {
  name: "StepperHeader",
  props: ["number", "step", "name"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.stepper {
  .header {
    display: flex;
    flex-flow: row wrap;
    overflow: hidden;
  }

  .step {
    --badgeSize: 16px;
    --badgeBorderWidth: 2px;
    position: relative;
    z-index: 2;
    width: 33.3333%;
    font-weight: var(--fontWeightBold);
    text-align: center;
    line-height: 1;
    color: var(--midGray);

    .title {
      display: block;
      margin-bottom: 0.75rem;
    }

    .badge {
      display: inline-block;
      width: var(--badgeSize);
      height: var(--badgeSize);
      border: var(--badgeBorderWidth) solid var(--ghostWhite);
      border-radius: 50%;
      background: var(--ghostWhite);
      text-align: center;
      text-indent: -99999px;

      &::before,
      &::after {
        content: "";
        position: absolute;
        z-index: -1;
        bottom: calc((var(--badgeSize) / 2) - (var(--badgeBorderWidth) / 2));
        right: calc(50% - (var(--badgeSize) / 2));
        width: calc(150% - (var(--badgeSize) / 2));
        height: var(--badgeBorderWidth);
        background-color: var(--ghostWhite);
      }

      &:after {
        background-color: var(--orange);
        transform: scaleX(0);
        transform-origin: left center;
        transition: transform 0.6s ease-in-out;
      }
    }

    &:first-child {
      text-align: left;

      &::before {
        display: none;
      }
    }

    &:last-child {
      text-align: right;

      .badge::before,
      .badge::after {
        right: 0;
      }
    }

    &.active,
    &.completed {
      color: var(--orange);

      .badge {
        border-color: var(--orange);

        &::after {
          transform: scaleX(1);
        }
      }
    }

    &.completed {
      .badge {
        background-color: var(--orange);
      }
    }

    @media (min-width: 640px) {
      --badgeSize: 24px;
      --badgeBorderWidth: 3px;

      .title {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
